import React, { useRef, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { ManagerEntity } from '@/shared/globalFunctions';

interface props {
  showVideo: boolean;
  blob: Blob | null;
}

const DebugVideo = observer((props: props) => {
  const player = ManagerEntity.player;
  const videoPlay = ManagerEntity.videoPlay;

  // Create a URL for the Blob

  // Ref to the video element
  const videoRef = useRef<HTMLVideoElement>(null);
  const videoWrapRef = useRef<HTMLDivElement>(null);
  const [videoUrl, setVideoUrl] = useState<string | null>(null);

  const [videoSize, setVideoSize] = useState({ width: '100%', height: '30%' });

  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (props.blob) {
      const videoUrl = URL.createObjectURL(props.blob);

      setVideoUrl(videoUrl);

      if (player) {
        player.debug.timeStampChangedDelegates = [changeVideoRefTime];
      }

      // Cleanup function to revoke the Blob URL when the component unmounts
      return () => {
        URL.revokeObjectURL(videoUrl);
      };
    }
    return;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.blob]);
  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      if (videoPlay) {
        video.play();
      } else {
        video.pause();
      }
    }
  }, [videoPlay]);

  const handleMouseDown = (e: any) => {
    setDragStart({ x: e.clientX, y: e.clientY });
    setIsDragging(true);
  };

  const handleMouseMove = (e: any) => {
    if (!isDragging) return;

    const deltaX = e.clientX - dragStart.x;
    let deltaY = e.clientY - dragStart.y;

    deltaY = -deltaY;

    console.log(deltaY);

    setVideoSize((prevSize) => {
      const videoHeight = videoWrapRef.current?.offsetHeight;
      if (videoHeight) {
        return {
          width: `${parseFloat(prevSize.width) + deltaX}px`,
          height: `${videoHeight + deltaY}px`,
        };
      } else {
        return {
          width: `${parseFloat(prevSize.width) + deltaX}px`,
          height: `${parseFloat(prevSize.height) + deltaY}px`,
        };
      }
    });

    setDragStart({ x: e.clientX, y: e.clientY });
  };
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  function changeVideoRefTime(timestamp: number) {
    if (videoRef.current) {
      const timestampInSeconds = timestamp / 1000;
      videoRef.current.currentTime = timestampInSeconds;
    }
  }

  if (!props.blob || !videoUrl || !player) {
    return <div></div>;
  }

  return (
    <div
      ref={videoWrapRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: videoSize.width,
        height: videoSize.height,
        overflow: 'hidden',
        zIndex: 9999,
        pointerEvents: 'auto'
      }}>
      <video
        ref={videoRef}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
        controls
        onClick={(e: any) => {
          e.preventDefault();
        }}
        src={videoUrl}
        muted={false} // Remove muted if you want audio to be played
      ></video>
    </div>
  );
});

export default DebugVideo;
